import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@mui/icons-material";
import axios from "axios";
import {
  Button,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Select,
  Table,
  Upload,
  Spin,
  Col,
  Row,
  Radio,
} from "antd";
import styled from "styled-components";
import { ReactComponent as Info } from "../../assets/Frame 2147225144.svg";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Trash } from "../../assets/trash.svg";
import { ReactComponent as UploadIcon } from "../../assets/uploadicon.svg";
import { ReactComponent as Tick } from "../../assets/tick.svg";
import { ReactComponent as Fileupload } from "../../assets/fonts/File_Upload.svg";

import { ReactComponent as Suspend } from "../../assets/suspend.svg";
import ViewDetailsDisciplinary from "./ViewDetailsDisciplinary";
import CategoryView from "./CategoryView";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getClientid, getUserInfo, getUserList, getMenuList, getUserRoleId } from "redux/selectors";
import { connect } from "react-redux";
import moment from "moment";
import {
  NON_EMPTY_REGEX,
  STATUS_CODE,
  VALIDATE_SYMBOL,
} from "common/Constants";
import { CALL_API } from "common/API";
import dayjs from "dayjs";
import { Record } from "immutable";
import { use } from "react";
import { UploadOutlined, PlusOutlined } from "@ant-design/icons";
const Styleddiv = styled.div`
  .header-disciplinary {
    display: flex;
    justify-content: space-between;
  }
  .header-text {
    font-size: 20px;
    font-weight: 500;
  }
  .create-disciplinary {
    width: 170px;
    height: 40px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
  }
  .total-ticket {
    font-size: 16px;
    font-weight: 400;
  }
  .adjust-margin {
    margin-top: 10px;
    margin-left: 3px;
  }
  .category-view {
    border: none;
    color: #2d53da;
    font-size: 16px;
    font-weight: 400;
  }
  .category-view:hover {
    background-color: #e3e8fc !important;
  }

  .all-field-style {
    display: flex;
    gap: 10px;
  }
  .searchbar {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .searchicon {
    color: #636980;
  }
  .category-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .category-dropdown:hover .ant-select-selector {
    border-color: #e2e2e8 !important;
  }
  .category-dropdown.ant-select-focused .ant-select-selector {
    border-color: #e2e2e8 !important;
  }
  .custom-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .custom-dropdown:hover .ant-select-selector {
    border-color: #e2e2e8 !important;
  }
  .custom-dropdown.ant-select-focused .ant-select-selector {
    border-color: #e2e2e8 !important;
  }
  .datepicker-style {
    width: 160px;
    height: 34px;
    border-radius: 24px;
  }
  .action-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
  }
  .ant-table {
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }
  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 500;
    color: #1f243b;
  }
  .ant-table-tbody > tr > td {
    font-size: 15.2px;
    font-weight: 400;
    color: #636980;
  }
  .created-by {
    position: relative;
    display: flex;
    align-items: center;
  }
  .created-by .name-text {
    display: block;
  }
  .created-by .action-icons {
    display: none;
    gap: 15px;
  }
  .hover-row .created-by .name-text {
    display: none;
  }
  .hover-row .created-by .action-icons {
    display: flex;
  }
  .clearance-text {
    color: #08c108;
  }
  .suspend-text {
    color: #2d53da;
    text-decoration: underline;
  }
  .no-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
  }
  .yes-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
  }
  .date-range-container {
    display: flex !important;
    gap: 10px;
  }
  .infostyle {
    margin-left: 5px;
    margin-top: -2px;
  }
`;
const StyledSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 5px !important; /* Adjust the value as needed */
  }
`;
const StyledInput = styled(Input)`
  border-radius: 5px !important; /* Adjust the value as needed */
`;
const StyledTextArea = styled(Input.TextArea)`
  border-radius: 5px !important; /* Adjust the value as needed */
`;

const StyledModal = styled(Modal)`
  .mini {
    color: #636980;
    font-weight: 400;
    font-size: 12px;
    margin-top: -22px;
  }
  .file-item {
    background-color: #f5f5fa;
    padding-left: 10px;
    border-radius: 5px;
    color: black;
    font-size: 16px;
    padding-bottom: 5px;
  }
  .remove-btn {
    font-size: 16px;
    font-weight: 400;
    color: black !important;
  }
  .uploaded-files {
    //  background-color:#E2E2E8;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
  }

  .upload-style1 .anticon-plus {
    position: relative;
    top: -4px; /* Adjust as needed */
  }
  .upload-style1 {
    height: 37px;
    border-radius: 5px;
    background-color: #e3e8fc;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
  }

  .ant-modal {
    top: 0 !important; /* Moves the modal to the top of the screen */
    margin-top: 0 !important; /* Remove any margin at the top */
    position: fixed !important; /* Ensure it stays fixed to the top */
  }
  .ant-modal-title {
    font-size: 18px;
    font-weight: 500;
  }
  .custom-cancel-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
  }
  .custom-ok-button {
    width: 135px;
    height: 34px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 400;
    background-color: #2d53da;
    color: #ffffff;
  }
  .custom-ok-button.loading {
    width: 160px; /* Wider when loading */
  }
  .form-split {
    display: flex;
    gap: 32px;
  }
  .input-width {
    width: 50%;
  }
     .input-width1 {
    width: 25%;
  }
       .input-width2 {
    width: 24%;
   margin-top:30px;
    margin-left:-20px;
  }
  .form-datepicker {
    border-radius: 5px;
    width: 100%;
  }
  .upload-style {
    width: 190px;
    height: 37px;
    border-radius: 5px;
    background-color: #e3e8fc;
    font-size: 16px;
    font-weight: 400;
    color: #2d53da;
  }
  .upload-icon {
    margin-bottom: 3px;
  }
  .button-style {
    gap: 20px;
  }
  .success-modal {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .sent-successfully {
    font-size: 16px;
    font-weight: 400;
  }
  .suspension-from {
    display: flex;
    gap: 150px;
  }
  .suspension-to {
    display: flex;
    gap: 167px;
  }
  .payment-type {
    display: flex;
    gap: 170px;
  }
  .suspension-title {
    font-weight: 500;
    font-size: 14px;
    color: #636980;
  }
  .suspension-data {
    font-weight: 400;
    font-size: 16px;
  }
  .close-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    color: #2d53da;
  }
  .no-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #2d53da;
    color: #2d53da;
  }
  .yes-button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
    background-color: #2d53da;
    color: #ffffff;
  }
  .delete-modal-text {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
  }
  .yes-no-button {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  .upload-container {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap; /* Prevents wrapping to the next line */
  }
`;
function HrMyDisciplinary({ clientId, userList, userInfo, menuList, userRoleId }) {
  const handleRemove = (file) => {
    setFileList((prevList) => {
      const updatedFileList = prevList.filter((item) => item.uid !== file.uid);
      return updatedFileList;
    });
    setFileData((prevData) => {
      const updatedFileData = prevData.filter((item) => item.uid !== file.uid);
      return updatedFileData;
    });
  };

  const [formData, setFormData] = useState({});
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedDisciplinary, setSelectedDisciplinary] = useState(null);
  const [selectedPath, setSelectedPath] = useState(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isSuspendModalOpen, setIsSuspendModalOpen] = useState(false);

  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeletedModalOpen, setIsDeletedModalOpen] = useState(false);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
  const [isSavedModalOpen, setIsSavedModalOpen] = useState(false);
  const [selectedCategoryView, setSelectedCategoryView] = useState(null);
  const [showDateRange, setShowDateRange] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [showLoader, toggleLoader] = useState(false);
  const [assetsData, setDisData] = useState([]);
  const [deletedata, setDeletedata] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [editData, setEditData] = useState([]);
  const [showmessage, setShowMessage] = useState(false);
  const [diciplinaryrecord, setDisciplinaryRecord] = useState({});
  const [disData, setDispData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [filtered, setFilteredData] = useState([]);
  const [filteredData, setFilteredData1] = useState([]);
  const [actionValue, setActionValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [fileData, setFileData] = useState([]);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0]; // Added Menulist logic
  const handleRowClick = (record) => {
    setSelectedPath(true);
    setSelectedDisciplinary(record);
    setDisciplinaryRecord(record);
  };

  const handleGoBack = () => {
    setSelectedPath(false);
  };

  const handleCreateDisciplinary = () => {
    setIsEditing(false);
    setSelectedDisciplinary(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  const parseDate = (date, format = "DD-MM-YYYY") =>
    dayjs(date, format).isValid() ? dayjs(date, format) : "";

  const handleEditDisciplinary = (record) => {
    setIsEditing(true);
    setSelectedDisciplinary(record);

    form.setFieldsValue({
      ...record,
      dateofincident: record.dateofincident
        ? moment(record.dateofincident)
        : null,
      employee: record?.userId,
      suspendfromdate: moment(
        record?.suspendfromdate
      ) || null,
      suspendtodate: moment(
        record?.suspendtodate
      ) || null,
    });


    if (Array.isArray(record?.evidence) && record.evidence.length > 0) {
      const fileListData = record.evidence.map((file, index) => ({
        uid: `${index}`,
        name: file?.fileName || `File-${index}`,
        fileName: file?.fileName,
        status: "done",
        url: file?.fileUrl || "",
        contentType: file?.contentType,
        base64Data: file?.base64Data,
      }));

      setFileList(fileListData);
      setFileData(fileListData);
    } else {
      setFileList([]);
      setFileData([]);
    }

    setIsModalOpen(true);
  };

  const history = useHistory();
  const handleCancel = () => {
    setFileList([]);
    setIsModalOpen(false);
  };
  const handleDeleteClick = (record) => {
    setSelectedDeleteRecord(record);
    setIsDeleteOpen(true);
  };
  const handleDeleteCancel = () => {
    setIsDeleteOpen(false);
  };
  const handleDeleteConfirm = () => {
    setIsDeleteOpen(false);
    setIsDeletedModalOpen(true);
    setTimeout(() => {
      setIsDeletedModalOpen(false);
    }, 2000);
  };

  const handleCategoryViewBack = () => {
    setSelectedCategoryView(false);
  };
  const [hoveredRowKey, setHoveredRowKey] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [suspendDetails, setSuspendDetails] = useState({
    suspendFromDate: "",
    suspendToDate: "",
    paymentType: "",
  });

  const handleCloseModal = () => {
    setIsModalVisible(false); // Close the modal
  };

  const columns = [
    {
      title: "Discip.ID",
      dataIndex: "disciplinaryId",
      key: "disciplinaryId",
    },
    {
      title: "Name",
      dataIndex: "employee",
      key: "employee",
    },
    {
      title: "Employee ID",
      dataIndex: "employeeId",
      key: "employeeId",
    },
    {
      title: "Date of Incident",
      dataIndex: "dateofincident",
      key: "dateofincident",
      render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Action",
      dataIndex: "actions",
      key: "actions",
      // render: (text, record) => {
      //   let displayStatus = text;
      //   console.log("actiontimeline", record.actiontimeline)
      //   if (record?.actiontimeline?.length > 1) {
      //     // Loop through the action timeline in reverse order and skip the current one
      //     for (let i = record.actiontimeline.length - 1; i >= 0; i--) {
      //       const action = record.actiontimeline[i].actionmoveon;
      //       if (action !== "Commented" && action !== "Update the ticket") {
      //         displayStatus = action;
      //         break;
      //       }
      //     }
      //   }

      //   return displayStatus;
      // }
    },


    {
      title: "Moved to",
      dataIndex: "actiontimeline",
      key: "actionmoveon",
      render: (actiontimeline, record) => {
        let lastAction = "-";
        if (Array.isArray(actiontimeline) && actiontimeline.length > 0) {
          for (let i = actiontimeline.length - 1; i >= 0; i--) {
            const action = actiontimeline[i]?.actionmoveon;
            if (
              typeof action === "string" &&
              action.trim().toLowerCase() !== "commented"
            ) {
              lastAction = action;
              break;
            }
          }
        }

        const getColor = (action) => {
          // Coerce action to lowercase string safely
          const safeAction =
            typeof action === "string"
              ? action.toLowerCase()
              : String(action ?? "").toLowerCase();

          console.log("action", safeAction);

          if (safeAction === "") return "black";

          return safeAction.includes("suspend")
            ? "#2D53DA"
            : safeAction.includes("first") ||
              safeAction.includes("second") ||
              safeAction.includes("verbal")
            ? "#119DE5"
            : safeAction.includes("third") || safeAction.includes("show cause")
            ? "#F28916"
            : safeAction.includes("demotion")
            ? "#8E2A5E"
            : safeAction.includes("exoneration") ||
              safeAction.includes("clearance")
            ? "#22AD22"
            : safeAction.includes("termination")
            ? "#D90325"
            : "#636980";
        };

        const handleSuspendClick = (record) => {
          setSuspendDetails({
            suspendFromDate: record?.suspendfromdate,
            suspendToDate: record?.suspendtodate,
            paymentType: record?.paymenttype,
          });
          setIsSuspendModalOpen(true);
        };

        const isSuspend = lastAction.toLowerCase() === "suspend";

        return (
          <span
            style={{
              color: getColor(lastAction),
              cursor: isSuspend ? "pointer" : "default",
              textDecoration: isSuspend ? "underline" : "none",
            }}
            onClick={(e) => {
              if (isSuspend) {
                e.stopPropagation(); // Prevent table row click
                handleSuspendClick(actiontimeline?.[actiontimeline.length - 1]);
              }
            }}
          >
            {lastAction}
            {isSuspend && <Info className="infostyle" />}
          </span>
        );
      },
    },
    {
      title: "Created on",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
    },

    {
      title: "Created by",
      dataIndex: "createdByUserName",
      key: "createdByUserName",
      render: (text, record) => (
        <div className="created-by">
          <span className="name-text">{text}</span>

          <span className="action-icons">
            {Menulist?.find(
              (item) =>
                item?.key === "mydisciplinary" &&
                item?.permission.edit
            ) && (
                <Edit
                  onClick={(event) => {
                    event.stopPropagation();
                    handleEditDisciplinary(record);
                  }}
                />)}
            {Menulist?.find(
              (item) =>
                item?.key === "mydisciplinary" &&
                item?.permission.delete
            ) && (
                <Trash
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteClick(record);
                  }}
                />)}
          </span>
        </div>
      ),
    },
  ];
  const [dateValue, setDateValue] = useState("");

  const handleFormSubmit = async (values) => {
    try {
      setLoading(true);
      const formData = await form.validateFields();
      const filteruser = userList?.filter(
        (item) => item?.userid === values?.employee
      );

      const file = values?.attachment; // Define `file` properly
      const cleanedEvidence = fileData?.map(file => ({
        contentType: file.contentType,
        fileName: file.fileName,
        base64Data: file.base64Data,
      }));
      const payload = {
        clientId: clientId,
        employee: filteruser[0]?.fullname,
        actions: values?.actions,
        category: values?.category,
        dateofincident: moment(values?.dateofincident).format("YYYY-MM-DD"),
        noofappeal: values?.noofappeal,
        description: values?.description,
        evidence: cleanedEvidence, // Use cleaned list here
        userId: filteruser[0]?.userid,
        createdByUserName: userInfo?.name,
        createdByUserId: userInfo?.userid,
        employeeId: filteruser[0]?.employeeid,
        suspendtodate: values?.suspendtodate,
        paymenttype: values?.paymenttype,
        suspendfromdate: values?.suspendfromdate,
      };
      // const secondpayload = {
      //   clientId: clientId,
      //   employee: filteruser[0]?.fullname,
      //   actions: values?.actions,
      //   category: values?.category,
      //   dateofincident: moment(values?.dateofincident).format("YYYY-MM-DD"),
      //   noofappeal: values?.noofappeal,
      //   description: values?.description,
      //   evidence: fileData,
      //   userId: filteruser[0]?.userid,
      //   createdByUserName: userInfo?.name,
      //   createdByUserId: userInfo?.userid,
      // };

      const formDataToSend = new FormData();
      formDataToSend.append("name", payload.employee);
      formDataToSend.append("category", payload.category);
      formDataToSend.append("action", payload.actions);
      formDataToSend.append("name", payload.dateofincident);
      formDataToSend.append("category", payload.noofappeal);
      formDataToSend.append("action", payload.description);
      if (payload.attachment) {
        formDataToSend.append("image", payload.attachment);
      }

      // Make POST request
      const { response, code } = await CALL_API(
        isEditing
          ? `disciplinary/${clientId}/${selectedDisciplinary?.disciplinaryId}`
          : "disciplinary",
        isEditing ? "patch" : "post",
        payload
      );

      if (code === STATUS_CODE.SUCCESS) {
        getDisData();
        setIsModalOpen(false);
        setIsSavedModalOpen(true);
        form.resetFields();
        setFileData();
        setFileList([]);
        setTimeout(() => {
          setIsSavedModalOpen(false);
        }, 2000);
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Failed to add asset. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // Table data source

  const getDisData = async () => {
    try {
      setLoading(true); // Show loader while fetching data

      // Make GET request
      const { data, code } = await CALL_API("disciplinary", "get", {});

      if (code === "SUCCESS") {
        const reversedData = data.reverse();

        setDisData(reversedData);
        setFilteredData1(reversedData);
      } else {
        message.error("Failed to fetch data. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while fetching data.");
    } finally {
      setLoading(false); // Hide loader after API call
    }
  };

  useEffect(() => {
    getDisData(); // Call the correct function
  }, []);
  const deleteDisci = async () => {
    // let name = editData.assetName;
    setDeleteLoading(true);

    try {
      const { code } = await CALL_API(
        `disciplinary/${clientId}/${selectedDeleteRecord?.disciplinaryId}`,
        "delete"
      );

      if (code === "SUCCESS") {
        getDisData();
        setDeleteLoading(false);
        setShowMessage(false);
        setDeletedata(false);
        setEditData([]);
        message("Deleted successfully");
      } else {
        message.error("Failed to Delete");
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setDeleteLoading(false);
    }
  };

  const getUserNames = (userList) => {
    return userList
      ?.filter((val) => val?.statusid === "1")
      .map((user) => ({
        name: user.fullname,
        userId: user.userid,
      }));
  };
  const userNames = getUserNames(userList);

  useEffect(() => {
    let filtered = assetsData;
    if (searchText) {
      filtered = filtered.filter((disciplinary) =>
        disciplinary?.employee?.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    if (selectedType) {
      filtered = filtered.filter(
        (disciplinary) =>
          disciplinary?.category?.trim().toLowerCase() ===
          selectedType.toLowerCase()
      );
    }
    if (actionValue) {
      filtered = filtered.filter((disciplinary) =>
        disciplinary?.actions
          ?.trim()
          .toLowerCase()
          .includes(actionValue.toLowerCase())
      );
    }
    let startDate, endDate;
    if (selectedDateRange === "Last week") {
      startDate = moment().subtract(1, "weeks").startOf("week");
      endDate = moment().subtract(1, "weeks").endOf("week");
    } else if (selectedDateRange === "Last month") {
      startDate = moment().subtract(1, "months").startOf("month");
      endDate = moment().subtract(1, "months").endOf("month");
    } else if (selectedDateRange === "Last 6 months") {
      startDate = moment().subtract(6, "months").startOf("month");
      endDate = moment().endOf("month");
    } else if (selectedDateRange === "Custom Date range") {
      startDate = moment(fromDate).startOf("day");
      endDate = moment(toDate).endOf("day");
    }
    if (
      startDate &&
      endDate &&
      !isNaN(new Date(startDate).getTime()) &&
      !isNaN(new Date(endDate).getTime())
    ) {
      filtered = filtered.filter((disciplinary) =>
        moment(disciplinary.dateofincident).isBetween(
          startDate,
          endDate,
          null,
          "[]"
        )
      );
    }

    setFilteredData1(filtered);
  }, [
    searchText,
    selectedType,
    assetsData,
    actionValue,
    selectedDateRange,
    fromDate,
    toDate,
  ]);
  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    if (value === "Custom Date range") {
      setShowDateRange(true);
    } else {
      setShowDateRange(false);
      setFromDate(null);
      setToDate(null);
    }
  };
  return (
    <>
      <Styleddiv>
        {selectedCategoryView ? (
          <CategoryView
            onBack={handleCategoryViewBack}
            getDisData={getDisData}
            disData={disData}
          />
        ) : selectedPath ? (
          <ViewDetailsDisciplinary
            data={diciplinaryrecord}
            onBack={handleGoBack}
            record={selectedDisciplinary}
            getDisData={getDisData}
            id={diciplinaryrecord?.disciplinaryId}
          />
        ) : (
          <div>
            <div className="header-disciplinary">
              <div className="header-text">Disciplinary Management</div>
              <div>
                {Menulist?.find(
                  (item) =>
                    item?.key === "mydisciplinary" &&
                    item?.permission.create
                ) && (
                    <Button
                      type="primary"
                      onClick={handleCreateDisciplinary}
                      className="create-disciplinary"
                    >
                      Create Disciplinary
                    </Button>)}
              </div>
            </div>
            <br />
            <div className="header-disciplinary">
              <div className="total-ticket">
                Total Tickets: {filteredData.length}
              </div>
              <Button
                className="category-view"
                onClick={() => {
                  history.push({
                    pathname: "/categoryview",
                    state: { DispData: assetsData },
                  });
                }}
              >
                Category View
              </Button>
            </div>
            <br />
            <div className="all-field-style">
              <Row gutter={16}>
                <Col>
                  <div>
                    <Input
                      className="searchbar"
                      placeholder="Search Name"
                      prefix={<SearchOutlined className="searchicon" />}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </div>
                </Col>
                <Col>
                  <div>
                    <Select
                      placeholder="Category"
                      className="category-dropdown"
                      onChange={(value) => setSelectedType(value)}
                      allowClear
                    >
                      <Select.Option value="Absence from duty without permission">
                        Absence from duty without permission
                      </Select.Option>
                      <Select.Option value="Unwillingness and inability to perform duties">
                        Unwillingness and inability to perform duties
                      </Select.Option>
                      <Select.Option value="Damage to Company property">
                        Damage to Company property
                      </Select.Option>
                      <Select.Option value="Loss of Company property">
                        Loss of Company property
                      </Select.Option>
                      <Select.Option value="Unauthorized possession of Company property">
                        Unauthorized possession of Company property
                      </Select.Option>
                      <Select.Option value="insubordination">
                        Insubordination
                      </Select.Option>
                      <Select.Option value="Use of abusive language, harassment, or bullying">
                        Use of abusive language, harassment, or bullying
                      </Select.Option>
                      <Select.Option value="Gross negligence">
                        Gross negligence
                      </Select.Option>
                      <Select.Option value="Wilful damage to or theft of company property">
                        Wilful damage to or theft of company property
                      </Select.Option>
                      <Select.Option value="Fraud or dishonesty in dealing with the company">
                        Fraud or dishonesty in dealing with the company
                      </Select.Option>
                      <Select.Option value="Theft or misappropriation of Company funds">
                        Theft or misappropriation of Company funds
                      </Select.Option>
                      <Select.Option value="Under drugs or alcohol during working hours">
                        Under drugs or alcohol during working hours
                      </Select.Option>
                      <Select.Option value="Noncompliance to standard oparting procedure">
                        Noncompliance to standard oparting procedure
                      </Select.Option>
                    </Select>
                  </div>
                </Col>
                <Col>
                  <div>
                    <Select
                      placeholder="Date"
                      className="action-dropdown"
                      onChange={handleSelectChange}
                      allowClear
                    >
                      <Select.Option value="Last week">Last week</Select.Option>
                      <Select.Option value="Last month">
                        Last month
                      </Select.Option>
                      <Select.Option value="Last 6 months">
                        Last 6 months
                      </Select.Option>
                      <Select.Option value="Custom Date range">
                        Custom Date range
                      </Select.Option>
                    </Select>
                  </div>
                </Col>
                {showDateRange && ( // Conditionally render the date pickers
                  <div className="date-range-container">
                    <Col>
                      <div>
                        <DatePicker
                          placeholder="From"
                          format="DD-MM-YYYY"
                          className="datepicker-style"
                          onChange={(dateofincident) => {
                            setFromDate(dateofincident);
                          }}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <DatePicker
                          placeholder="To"
                          format="DD-MM-YYYY"
                          className="datepicker-style"
                          onChange={(dateofincident) =>
                            setToDate(dateofincident)
                          }
                          disabledDate={(current) =>
                            fromDate
                              ? current && current.isBefore(fromDate, "day")
                              : false
                          }
                        />
                      </div>
                    </Col>
                  </div>
                )}

                <Col
                  className={`dropdown-container ${showDateRange ? "adjust-margin" : ""
                    }`}
                >
                  <div>
                    <Select
                      placeholder="Action"
                      className="action-dropdown"
                      onChange={(value) => setActionValue(value)}
                      allowClear
                    >
                      <Select.Option value="Verbal Warning">
                        Verbal Warning
                      </Select.Option>
                      <Select.Option value="First Warning">
                        First Warning
                      </Select.Option>
                      <Select.Option value="Second Warning">
                        Second Warning
                      </Select.Option>
                      <Select.Option value="Third & Final Warning">
                        Third & Final Warning
                      </Select.Option>
                      <Select.Option value="Show Cause">
                        Show Cause
                      </Select.Option>
                      <Select.Option value="Suspend">Suspend</Select.Option>
                      <Select.Option value="Demotion">Demotion</Select.Option>
                      <Select.Option value="exoneration">
                        Exoneration
                      </Select.Option>
                      <Select.Option value="Clearance">Clearance</Select.Option>
                      <Select.Option value="Termination">
                        Termination
                      </Select.Option>
                    </Select>
                  </div>
                </Col>
              </Row>
            </div>
            <br />
            <div>
              <Spin spinning={loading} size="medium">
                <Table
                  columns={columns}
                  dataSource={filteredData}
                  rowKey="disciplinaryId" // Ensure each row has a unique key
                  onRow={(record) => ({
                    onMouseEnter: () => setHoveredRow(record.disciplinaryId), // Use `disciplinaryId`
                    onMouseLeave: () => setHoveredRow(null),
                    className:
                      hoveredRow === record.disciplinaryId ? "hover-row" : "",
                    onClick: (e) => {
                      e.stopPropagation();
                      handleRowClick(record);
                    },
                  })}
                  scroll={{ x: "max-content" }}
                  style={{ cursor: "pointer" }}
                />
              </Spin>
              {selectedPath && diciplinaryrecord && (
                <ViewDetailsDisciplinary
                  record={diciplinaryrecord}
                  id={diciplinaryrecord?.disciplinaryId}
                />
              )}
            </div>
            <StyledModal
              width={950}
              height={120}
              title={
                isEditing
                  ? `Editing Disciplinary (${selectedDisciplinary?.disciplinaryId})`
                  : "Creating Disciplinary"
              }
              open={isModalOpen}
              onOk={handleFormSubmit}
              onCancel={handleCancel}
              getDisData={getDisData}
              assetsData={assetsData}
              // cancelText="Cancel"
              // okText="Create & Send"
              // okButtonProps={{ className: "custom-ok-button" }}
              // cancelButtonProps={{ className: "custom-cancel-button" }}
              style={{ top: "10px" }}
              footer={false}
            // className="custom-modal-footer"
            >
              <Form
                layout="vertical"
                name="disciplinary-form"
                form={form}
                onFinish={handleFormSubmit}
                onValuesChange={(value, allvalue) => setFormData(allvalue)}
              >
                <Form.Item
                  label="Employee"
                  name="employee"
                  rules={[
                    { required: true, message: "Please select an employee" },
                  ]}
                >
                  <StyledSelect
                    placeholder="Select employee"
                    optionLabelProp="label"
                  >
                    {userNames.map((item, index) => (
                      <Select.Option
                        key={index}
                        value={item.userId}
                        label={item.name}
                      >
                        {item.name}
                      </Select.Option>
                    ))}
                  </StyledSelect>
                </Form.Item>

                <div className="form-split">
                  <div className="input-width">
                    <Form.Item
                      label="Category"
                      name="category"
                      rules={[
                        { required: true, message: "Please select category" },
                      ]}
                    >
                      <StyledSelect placeholder="Criminal Offense">
                        <Select.Option value="Absence from duty without permission">
                          Absence from duty without permission
                        </Select.Option>
                        <Select.Option value="Unwillingness and inability to perform duties">
                          Unwillingness and inability to perform duties
                        </Select.Option>
                        <Select.Option value="Damage to Company property">
                          Damage to Company property
                        </Select.Option>
                        <Select.Option value="Loss of Company property">
                          Loss of Company property
                        </Select.Option>
                        <Select.Option value="Unauthorized possession of Company property">
                          Unauthorized possession of Company property
                        </Select.Option>
                        <Select.Option value="Insubordination">
                          Insubordination
                        </Select.Option>
                        <Select.Option value="Use of abusive language, harassment, or bullying">
                          Use of abusive language, harassment, or bullying
                        </Select.Option>
                        <Select.Option value="Gross negligence">
                          Gross negligence
                        </Select.Option>
                        <Select.Option value="Wilful damage to or theft of company property">
                          Wilful damage to or theft of company property
                        </Select.Option>
                        <Select.Option value="Fraud or dishonesty in dealing with the company">
                          Fraud or dishonesty in dealing with the comapny
                        </Select.Option>
                        <Select.Option value="Theft or misappropriation of Company funds">
                          Theft or misappropriation of Company funds
                        </Select.Option>
                        <Select.Option value="Under drugs or alcohol during working hours">
                          Under drugs or alcohol during working hours
                        </Select.Option>
                        <Select.Option value="Noncompliance to standard oparting procedure">
                          Noncompliance to standard oparting procedure
                        </Select.Option>
                      </StyledSelect>
                    </Form.Item>
                  </div>
                  <div className="input-width">
                    <Form.Item
                      label="Action"
                      name="actions"
                      rules={[
                        { required: true, message: "Please select action" },
                      ]}
                    >
                      <StyledSelect placeholder="First Warning">
                        <Select.Option value="Verbal Warning">
                          Verbal Warning
                        </Select.Option>
                        <Select.Option value="First Warning">
                          First Warning
                        </Select.Option>
                        <Select.Option value="Second Warning">
                          Second Warning
                        </Select.Option>
                        <Select.Option value="Third & Final Warning">
                          Third & Final Warning
                        </Select.Option>
                        <Select.Option value="Show Cause">
                          Show Cause
                        </Select.Option>
                        <Select.Option value="Suspend">Suspend</Select.Option>
                        <Select.Option value="Demotion">Demotion</Select.Option>
                        <Select.Option value="Exoneration">
                          Exoneration
                        </Select.Option>
                        <Select.Option value="Clearance">
                          Clearance
                        </Select.Option>
                        <Select.Option value="Termination">
                          Termination
                        </Select.Option>
                      </StyledSelect>
                    </Form.Item>
                  </div>
                </div>

                <div className="form-split">
                  <div className="input-width">
                    <Form.Item
                      label="Date of Incident"
                      name="dateofincident"
                      rules={[
                        {
                          required: true,
                          message: "Please select date of incident",
                        },
                      ]}
                    >
                      <DatePicker
                        className="form-datepicker"
                        // defaultValue={dateValue ? dayjs(dateValue) : null} // Ensure dateValue is parsed into a Moment object
                        format="Do MMMM, YYYY"
                        // }} // Save as ISO format
                        placeholder="Select a date"
                      />
                    </Form.Item>
                  </div>
                  <div className="input-width">
                    <Form.Item
                      label="Number of Appeals the employee can have"
                      name="noofappeal"
                      rules={[
                        {
                          required: true,
                          message: "Please enter Number of Appeals",
                        },
                      ]}
                    >
                      <StyledInput
                        placeholder="Number of Appeals"
                        maxLength={1}
                        onKeyDown={(e) => {
                          if (!/^[1-9]$/.test(e.key) && e.key !== "Backspace") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>
                    <p className="mini">
                      Minimum of 1 Appeal not less than that{" "}
                    </p>
                  </div>
                </div>
                {(form.getFieldValue('actions') === "Suspend") && (
                  <div className="form-split">
                    <div className="input-width1">
                      <Form.Item
                        label="Suspension Duration"
                        name="suspendfromdate"
                        rules={[
                          {
                            required: true,
                            message: "Please select date of incident",
                          },
                        ]}
                      >
                        <DatePicker
                          className="form-datepicker"
                          format="Do MMMM, YYYY"
                          placeholder="Select a date"
                          value={suspendDetails?.suspendFromDate ? moment(suspendDetails?.suspendFromDate) : null}
                        />
                      </Form.Item></div>
                    <div className="input-width2">
                      <Form.Item
                        label=""
                        name="suspendtodate"
                        rules={[
                          {
                            required: true,
                            message: "Please select date of incident",
                          },
                        ]}
                      >
                        <DatePicker
                          className="form-datepicker"
                          format="Do MMMM, YYYY"
                          placeholder="Select a date"
                          value={suspendDetails?.suspendToDate ? moment(suspendDetails?.suspendToDate) : null}
                        // value={selectedDate} // Use value instead of defaultValue
                        // onChange={(date) => setSelectedDate(date)}
                        />
                      </Form.Item>
                    </div>
                    <div className="input-width">
                      <Form.Item label="Payment Type" name="paymenttype">
                        <Radio.Group
                          value={
                            selectedDisciplinary?.actiontimeline?.[
                              selectedDisciplinary?.actiontimeline?.length - 1
                            ]?.paymenttype
                          }
                        >
                          <Radio value="With Pay">With Pay</Radio>
                          <Radio value="Without Pay">Without Pay</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </div>
                  </div>
                )}

                <Form.Item
                  label="Description"
                  name="description"
                  rules={[
                    {
                      required: true,
                      message: "Please enter description",
                    },
                  ]}
                >
                  <StyledTextArea
                    placeholder="Description"
                    maxLength={250}
                    autoSize={{ minRows: 2, maxRows: 6 }}
                  />
                </Form.Item>
                <p className="mini">Maximum 250 Characters </p>
                <Form.Item label="Attachment (Optional)" name="attachment">
                  <div className="upload-container">
                    {fileList.length > 0 && (
                      <div className="uploaded-files">
                        {fileList.map((file) => (
                          <span key={file.uid} className="file-item">
                            <span>{file.name}</span> {/* Ensure 'name' is used */}
                            <Button
                              type="text"
                              className="remove-btn"
                              onClick={() => handleRemove(file)}
                            >
                              &times;
                            </Button>
                          </span>
                        ))}

                      </div>
                    )}

                    <Upload
                      fileList={fileList}
                      customRequest={({ file, onSuccess, onError }) => {
                        const maxSizeMB = 25;
                        const fileSizeMB = file.size / (1024 * 1024);
                        const isMp4 = file.type === "video/mp4";

                        // ❌ Block MP4 file types
                        if (isMp4) {
                          message.error("MP4 video files are not allowed.");
                          onError("MP4 video files are not allowed.");
                          return;
                        }

                        // ❌ Block files over 25MB
                        if (fileSizeMB > maxSizeMB) {
                          message.error("File size must be less than 25MB");
                          onError("File size exceeds 25MB");
                          return;
                        }

                        // ✅ Proceed with file reading and uploading
                        const reader = new FileReader();
                        reader.readAsDataURL(file);

                        reader.onload = () => {
                          const base64Data = reader.result.split(",")[1];
                          onSuccess();

                          setFileData((prevList) => {
                            const safePrevList = Array.isArray(prevList) ? prevList : [];

                            return [
                              ...safePrevList,
                              {
                                base64Data: base64Data,
                                contentType: file.type,
                                fileName: file.name,
                              },
                            ];
                          });

                          setFileList((prevList) => [
                            ...prevList,
                            {
                              uid: file.uid,
                              name: file.name,
                              status: "done",
                              url: reader.result,
                            },
                          ]);
                        };

                        reader.onerror = (error) => {
                          console.error("File read error:", error);
                          onError("File read error");
                        };
                      }}



                      onRemove={() => {
                        setFileData({
                          fileName: "",
                          fileType: "",
                          base64: "",
                        });
                        setFileList([]);
                      }}
                      showUploadList={false} // Ensures delete option is visible
                    >
                      {fileList.length === 0 ? (
                        <Button className="upload-style">
                          <Fileupload
                            style={{
                              position: "relative", // Enables movement
                              top: "-2px", // Moves the icon upwards
                              fontSize: "16px", // Ensures correct icon size
                              // marginLeft: "-10px",
                              marginRight: "5px",
                            }}
                          />
                          Add Attachment
                        </Button>
                      ) : (
                        <Button className="upload-style1">
                          <PlusOutlined />
                        </Button>
                      )}
                    </Upload>
                  </div>
                </Form.Item>
                <div className="d-flex justify-content-end gap-2">
                  <Button
                    className="custom-cancel-button"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  {isEditing ? (
                    <Button
                      className={`custom-ok-button ${loading ? "loading" : ""}`}
                      loading={loading}
                      // onClick={() => {
                      //   handleFormSubmit();
                      // }}
                      htmlType="submit"
                    >
                      Save Changes
                    </Button>
                  ) : (
                    <Button
                      className={`custom-ok-button ${loading ? "loading" : ""}`}
                      htmlType="submit"
                      loading={loading}
                    // onClick={() => {
                    //   handleFormSubmit();
                    //   getDisData();
                    // }}
                    >
                      Create & Send
                    </Button>
                  )}
                </div>
              </Form>
            </StyledModal>
            <StyledModal
              width={190}
              height={70}
              open={isSavedModalOpen}
              onCancel={() => setIsSavedModalOpen(false)}
              footer={false}
              closable={false}
              style={{ marginTop: "130px" }}
            >
              <div className="success-modal">
                <Tick />
                <p className="sent-successfully">
                  {isEditing ? "Changes Saved" : "Sent successfully"}
                </p>
              </div>
            </StyledModal>
            <StyledModal
              width={570}
              height={300}
              title="Suspension Details"
              open={isSuspendModalOpen}
              onCancel={() => setIsSuspendModalOpen(false)}
              footer={[
                <Button
                  key="cancel"
                  onClick={() => setIsSuspendModalOpen(false)}
                  className="close-button"
                >
                  Close
                </Button>,
              ]}
            >
              <div className="suspension-from">
                <div className="suspension-title">Suspension From</div>
                <div className="suspension-data">
                  {" "}
                  {moment(suspendDetails.suspendFromDate).format("Do MMM YYYY")}
                </div>
              </div>
              <br />
              <div className="suspension-to">
                <div className="suspension-title">Suspension To</div>
                <div className="suspension-data">
                  {moment(suspendDetails.suspendToDate).format("Do MMM YYYY")}
                </div>
              </div>
              <br />
              <div className="payment-type">
                <div className="suspension-title">Payment Type</div>
                <div className="suspension-data">
                  {suspendDetails.paymentType}
                </div>
              </div>
            </StyledModal>
            <StyledModal
              width={470}
              height={140}
              footer={false}
              closable={false}
              open={isDeleteOpen}
              onCancel={handleDeleteCancel}
              style={{ marginTop: "100px" }}
            >
              <p className="delete-modal-text">
                Are you sure you want to delete this disciplinary ticket?
              </p>
              <br />
              <div className="yes-no-button">
                <Button onClick={handleDeleteCancel} className="no-button">
                  No
                </Button>
                <Button
                  loading={deleteLoading}
                  onClick={async () => {
                    await deleteDisci(); // Call delete function
                    handleDeleteConfirm(); // Call after delete completes
                  }}
                  className="yes-button"
                >
                  Yes
                </Button>
              </div>
            </StyledModal>
            <StyledModal
              width={190}
              height={70}
              open={isDeletedModalOpen}
              onCancel={() => setIsDeletedModalOpen(false)}
              footer={false}
              closable={false}
              style={{ marginTop: "130px" }}
            >
              <div className="success-modal">
                <Tick />
                <p className="sent-successfully">Deleted</p>
              </div>
            </StyledModal>
          </div>
        )}
      </Styleddiv>
    </>
  );
}

const mapStateToProps = (state) => ({
  clientId: getClientid(state),
  userList: getUserList(state),
  userInfo: getUserInfo(state),
  menuList: getMenuList(state),
  userRoleId: getUserRoleId(state),
});

export default connect(mapStateToProps)(HrMyDisciplinary);
